import { propClassName } from '@/styles/404';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils';
import { Http404DescriptionComponent } from './404.Description';
import { Http404HeadlineComponent } from './404.Headline';

export interface Http404Props extends ComponentProps<'section'> {
  colors?: ClassNameProp;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

const Http404Component: Component<Http404Props> = ({ children, className, colors, size, variant, ...props }) => {
  const colorsClassName = propClassName('colors', colors, 'default');
  const sizeClassName = propClassName('size', size, 'default');
  const variantClassName = propClassName('variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <section className={componentClassName} {...props}>
      {children}
    </section>
  );
};

export const Http404 = Object.assign(Http404Component, {
  Headline: Http404HeadlineComponent,
  Description: Http404DescriptionComponent,
});
